import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { mixed, object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import BotaoLink from 'Component/BotaoLink';
import Cabecalho from 'Component/Cabecalho';
import Form, { Arquivo, Botao, Campo, Contexto, Selecao } from 'Component/Form';
import LayoutDefault from 'Component/Layout';
import ArquivoInterface from 'Interface/Arquivos';
import { NOMES_DE_ARQUIVOS } from 'View/constants';
import { useAdicionarArquivoMutation } from 'View/Service/Default/Arquivos';

const regras = object({
  // selecao_de_nome: string().required('Obrigatório'),
  nome: string().when('selecao_de_nome', {
    is: 'Outro',
    then: string().required('Obrigatório'),
    otherwise: string().nullable().optional(),
  }),
  url: mixed().required('Obrigatório'),
});

const Adicionar = (): React.ReactElement => {
  const toast = useToast();
  const navegacao = useNavigate();
  const { entidade = '', id = 0 } = useParams();
  const [adicionarArquivo] = useAdicionarArquivoMutation();

  const enviar = async (
    dados: ArquivoInterface & { selecao_de_nome: string }
  ): Promise<void> => {
    try {
      await adicionarArquivo({
        url: dados.url,
        nome:
          dados.nome ? dados.nome : dados.selecao_de_nome,
        entidade,
        entidade_id: id as number,
      }).unwrap();

      toast({ conteudo: 'Adicionado com sucesso!', tema: 'success' });

      navegacao(`/${entidade}/editar/${id}`);
    } catch (error) {
      toast({
        titulo: 'Erro ao adicionar',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Adicionando arquivo"
        descricao="Preencha o formulário e clique em enviar para adicionar o arquivo"
      />
      <Form onSubmit={enviar} regras={regras}>
        <div className="row justify-content-center">
          <div className="col-md-4">
            <div className="bg-white shadow-sm rounded p-4">
              <Arquivo name="url" />
              {entidade != 'empresas' ? (
                <>
                  <Selecao
                    name="selecao_de_nome"
                    rotulo="Qual é o arquivo?"
                    opcoes={NOMES_DE_ARQUIVOS}
                  />
                  <Contexto>
                    {({ values }) => (
                      <React.Fragment>
                        {values.selecao_de_nome == 'Outro' && (
                          <Campo
                            name="nome"
                            rotulo="Dê um nome para seu arquivo"
                          />
                        )}
                      </React.Fragment>
                    )}
                  </Contexto>
                </>
              ) : (
                <Campo name="nome" rotulo="Dê um nome para seu arquivo" />
              )}

              <div className="mt-5">
                <Botao>Enviar</Botao>
                <BotaoLink
                  tema="light"
                  to={`/${entidade}/editar/${id}`}
                  className="ms-2"
                >
                  Cancelar
                </BotaoLink>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </LayoutDefault>
  );
};

export default Adicionar;
